// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27white%27%3e%3cpath d=%27M7 10l5 5 5-5z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-management {
  color: white;
}

.user-controls {
  margin-bottom: 20px;
}

.add-user-button {
  background-color: #2196F3;
  color: white;
  border: none;
  padding: 8px 16px;
  height: 36px;
  border-radius: 4px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}

.add-user-button:hover {
  background-color: #1976D2;
}

.table-container {
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
  background-color: rgba(255, 255, 255, 0.05);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  color: white;
}

th, td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

th {
  background-color: rgba(255, 255, 255, 0.1);
  font-weight: 600;
}

tr:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.edit-button {
  background-color: #2196F3;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 4px;
  cursor: pointer;
}

.edit-button:hover {
  background-color: #1976D2;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal {
  background-color: #011029;
  border-radius: 8px;
  padding: 20px;
  width: 90%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  color: white;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: white;
}

.close-button:hover {
  color: #2196F3;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: 500;
  color: white;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  font-size: 14px;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #2196F3;
}

.password-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input-container input {
  padding-right: 40px;
}

.password-toggle {
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  color: white;
}

.modal-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
}

.submit-button,
.cancel-button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.submit-button {
  background-color: #2196F3;
  color: white;
}

.submit-button:hover {
  background-color: #1976D2;
}

.cancel-button {
  background-color: #f44336;
  color: white;
}

.cancel-button:hover {
  background-color: #d32f2f;
}

.error-container {
  margin: 10px 0;
  padding: 10px;
  background-color: rgba(244, 67, 54, 0.1);
  border: 1px solid rgba(244, 67, 54, 0.3);
  border-radius: 4px;
  color: #f44336;
}

.no-users {
  text-align: center;
  padding: 20px;
  color: rgba(255, 255, 255, 0.7);
}

@media (max-width: 768px) {
  .modal {
    width: 95%;
  }
}

.create-user-button {
  background-color: #2196F3;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.create-user-button:hover {
  background-color: #1976D2;
}

/* Responsive styles */
@media (max-width: 1200px) {
  .user-management {
    padding: 1rem;
  }
  
  .table-container {
    border-radius: 0;
    width: 100%;
  }
}

/* Custom scrollbar for better UX */
.table-container::-webkit-scrollbar {
  height: 8px;
}

.table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.table-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.editable-cell {
  cursor: pointer;
  padding: 0.5rem;
  display: block;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.editable-cell:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

.editable-input {
  width: 100%;
  padding: 0.5rem;
  border: 2px solid #2196F3;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  font-size: inherit;
  font-family: inherit;
}

.editable-input:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.25);
}

.role-select {
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  min-width: 120px;
  transition: all 0.2s ease;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 20px;
  padding-right: 32px;
}

.role-select:hover {
  border-color: rgba(255, 255, 255, 0.3);
  background-color: rgba(255, 255, 255, 0.15);
}

.role-select:focus {
  outline: none;
  border-color: #2196F3;
  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.25);
}

.role-select option {
  background-color: #011029;
  color: white;
  padding: 8px;
}

.status-badge {
  width: 100px;
  padding: 0.5rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  text-align: center;
  transition: all 0.3s ease;
}

.status-badge.active {
  background-color: rgba(76, 175, 80, 0.2);
  color: #4CAF50;
}

.status-badge.inactive {
  background-color: rgba(244, 67, 54, 0.2);
  color: #f44336;
}

.status-badge:hover {
  opacity: 0.8;
}

.actions-cell {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.delete-btn {
  background: none;
  border: none;
  color: rgba(244, 67, 54, 0.7);
  cursor: pointer;
  padding: 0.5rem;
  font-size: 1.1rem;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
}

.delete-btn:hover {
  color: #f44336;
  transform: scale(1.1);
}

/* Header with create button */
.header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.create-user-button {
  background-color: #2196F3;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s;
}

.create-user-button:hover {
  background-color: #1976D2;
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal {
  background: #011029;
  padding: 2rem;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  color: white;
}

.modal h3 {
  margin-top: 0;
  margin-bottom: 1.5rem;
}

.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: white;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  font-size: 1rem;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #2196F3;
  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.25);
}

.modal-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 1.5rem;
}

.submit-button {
  padding: 0.5rem 1rem;
  background-color: #2196F3;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.submit-button:hover {
  background-color: #1976D2;
}

.cancel-button {
  padding: 0.5rem 1rem;
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.cancel-button:hover {
  background-color: #d32f2f;
}

/* Responsive styles */
@media (max-width: 768px) {
  .modal-overlay {
    padding: 1rem;
  }

  .modal-content {
    padding: 1.5rem;
    max-height: 85vh; /* Slightly smaller on mobile */
  }

  .header-actions {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
  
  .create-user-button {
    width: 100%;
  }
}

/* Add smooth scrollbar styling */
.modal-content::-webkit-scrollbar {
  width: 8px;
}

.modal-content::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.modal-content::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Optional: Add a close button at the top */
.modal-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  line-height: 1;
}

.modal-close:hover {
  color: #2196F3;
}

.loading-container,
.error-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  padding: 2rem;
}

.loading {
  color: white;
  font-size: 1.2rem;
}

.error {
  color: #f44336;
  font-size: 1.2rem;
  text-align: center;
  padding: 1rem;
  background-color: rgba(244, 67, 54, 0.1);
  border-radius: 4px;
  max-width: 600px;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #2196F3;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.refresh-button {
  background-color: #2196F3;
  color: white;
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 1rem;
}

.refresh-button:hover {
  background-color: #1976D2;
}

.last-refresh {
  font-size: 0.8rem;
  color: white;
  margin-bottom: 1rem;
}

/* Column widths */
th:nth-child(1), td:nth-child(1) { width: 20%; } /* Name */
th:nth-child(2), td:nth-child(2) { width: 25%; } /* Email */
th:nth-child(3), td:nth-child(3) { width: 15%; } /* Role */
th:nth-child(4), td:nth-child(4) { width: 15%; } /* Created */
th:nth-child(5), td:nth-child(5) { width: 15%; } /* Last Login */
th:nth-child(6), td:nth-child(6) { width: 10%; } /* Actions */

.user-controls {
  margin-bottom: 1rem;
}

.add-user-button {
  padding: 0.5rem 1rem;
  background-color: #2196F3;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.add-user-button:hover {
  background-color: #1976D2;
}

.edit-button {
  padding: 0.5rem 1rem;
  background-color: #2196F3;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.edit-button:hover {
  background-color: #1976D2;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #2196F3;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-container {
  padding: 1rem;
  background-color: rgba(244, 67, 54, 0.1);
  border: 1px solid rgba(244, 67, 54, 0.3);
  border-radius: 4px;
  margin: 1rem 0;
}

.error-message {
  color: #f44336;
  margin: 0;
}

.no-users {
  text-align: center;
  padding: 2rem;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
}

/* Make table responsive */
@media screen and (max-width: 1024px) {
  .table-container {
    width: 100%;
    border-radius: 0;
  }
  
  .user-management {
    padding: 1rem;
  }
}

/* Style for editable cells */
td span {
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 4px;
}

td span:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

td input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  font-size: inherit;
  font-family: inherit;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
}

td input:focus {
  outline: none;
  border-color: #2196F3;
  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.25);
}

.modal-error {
  background-color: rgba(244, 67, 54, 0.1);
  color: #f44336;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 1rem;
  border: 1px solid rgba(244, 67, 54, 0.3);
}

.form-group input:disabled,
.form-group select:disabled,
button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.submit-button:disabled {
  background-color: #ccc;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;
  color: white;
}

.close-button:hover {
  color: #2196F3;
}

.close-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.try-again-button {
  margin-left: 1rem;
  padding: 0.25rem 0.5rem;
  background-color: #f44336;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.try-again-button:hover {
  background-color: #d32f2f;
}

.password-input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input-container input {
  padding-right: 40px; /* Make room for the eye icon */
  width: 100%;
}

.password-toggle {
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  display: flex;
  align-items: center;
  color: white;
}

.password-toggle:hover {
  color: #2196F3;
}

.password-toggle:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.password-toggle svg {
  width: 20px;
  height: 20px;
}

/* Update existing form-group styles */
.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: white;
}

.form-group input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  font-size: 1rem;
  background-color: rgba(255, 255, 255, 0.1);
  color: white;
}

.form-group input:focus {
  outline: none;
  border-color: #2196F3;
  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.25);
}

.location-cell {
  min-width: 250px;
  padding: 0.5rem !important;
}

.location-select-container {
  width: 100%;
}

.location-select__control {
  min-height: 38px !important;
  background-color: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.2) !important;
  border-radius: 4px !important;
}

.location-select__control:hover {
  border-color: #2196F3 !important;
}

.location-select__control--is-focused {
  border-color: #2196F3 !important;
  box-shadow: 0 0 0 1px #2196F3 !important;
}

.location-select__menu {
  background-color: #011029 !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;
}

.location-select__option {
  background-color: transparent !important;
  color: white !important;
  cursor: pointer !important;
}

.location-select__option--is-focused {
  background-color: rgba(255, 255, 255, 0.1) !important;
}

.location-select__option--is-selected {
  background-color: rgba(33, 150, 243, 0.2) !important;
}

.location-select__multi-value {
  background-color: rgba(255, 255, 255, 0.1) !important;
  border-radius: 4px !important;
}

.location-select__multi-value__label {
  color: white !important;
  padding: 2px 6px !important;
}

.location-select__multi-value__remove {
  color: white !important;
  cursor: pointer !important;
  padding: 0 4px !important;
}

.location-select__multi-value__remove:hover {
  background-color: rgba(244, 67, 54, 0.2) !important;
  color: #f44336 !important;
}

.location-select__input {
  color: white !important;
}

.location-select__placeholder {
  color: rgba(255, 255, 255, 0.5) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/admin/UserManagement.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,2CAA2C;EAC3C,wCAAwC;EACxC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA;EACE,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,0CAA0C;EAC1C,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,wCAAwC;EACxC,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;AACF;;AAEA,mCAAmC;AACnC;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,yDAA+K;EAC/K,4BAA4B;EAC5B,qCAAqC;EACrC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,yCAAyC;EACzC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,0CAA0C;EAC1C,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB,EAAE,+BAA+B;EACnD;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,iCAAiC;AACjC;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB,mCAAmC,UAAU,EAAE,EAAE,SAAS;AAC1D,mCAAmC,UAAU,EAAE,EAAE,UAAU;AAC3D,mCAAmC,UAAU,EAAE,EAAE,SAAS;AAC1D,mCAAmC,UAAU,EAAE,EAAE,YAAY;AAC7D,mCAAmC,UAAU,EAAE,EAAE,eAAe;AAChE,mCAAmC,UAAU,EAAE,EAAE,YAAY;;AAE7D;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,aAAa;EACb,wCAAwC;EACxC,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,wCAAwC;EACxC,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;;;EAGE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB,EAAE,+BAA+B;EACpD,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,sCAAsC;AACtC;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,eAAe;EACf,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,0CAA0C;EAC1C,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,qDAAqD;EACrD,iDAAiD;EACjD,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,qDAAqD;EACrD,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;EACxC,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,qDAAqD;EACrD,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;AAC5C","sourcesContent":[".user-management {\n  color: white;\n}\n\n.user-controls {\n  margin-bottom: 20px;\n}\n\n.add-user-button {\n  background-color: #2196F3;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  height: 36px;\n  border-radius: 4px;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n}\n\n.add-user-button:hover {\n  background-color: #1976D2;\n}\n\n.table-container {\n  overflow-x: auto;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: rgba(255, 255, 255, 0.05);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n  color: white;\n}\n\nth, td {\n  padding: 12px 15px;\n  text-align: left;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\nth {\n  background-color: rgba(255, 255, 255, 0.1);\n  font-weight: 600;\n}\n\ntr:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.edit-button {\n  background-color: #2196F3;\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.edit-button:hover {\n  background-color: #1976D2;\n}\n\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal {\n  background-color: #011029;\n  border-radius: 8px;\n  padding: 20px;\n  width: 90%;\n  max-width: 500px;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);\n  color: white;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n  color: white;\n}\n\n.close-button:hover {\n  color: #2196F3;\n}\n\n.form-group {\n  margin-bottom: 15px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 5px;\n  font-weight: 500;\n  color: white;\n}\n\n.form-group input,\n.form-group select {\n  width: 100%;\n  padding: 8px 12px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n  font-size: 14px;\n  background-color: rgba(255, 255, 255, 0.1);\n  color: white;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #2196F3;\n}\n\n.password-input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.password-input-container input {\n  padding-right: 40px;\n}\n\n.password-toggle {\n  position: absolute;\n  right: 10px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: white;\n}\n\n.modal-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.submit-button,\n.cancel-button {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.submit-button {\n  background-color: #2196F3;\n  color: white;\n}\n\n.submit-button:hover {\n  background-color: #1976D2;\n}\n\n.cancel-button {\n  background-color: #f44336;\n  color: white;\n}\n\n.cancel-button:hover {\n  background-color: #d32f2f;\n}\n\n.error-container {\n  margin: 10px 0;\n  padding: 10px;\n  background-color: rgba(244, 67, 54, 0.1);\n  border: 1px solid rgba(244, 67, 54, 0.3);\n  border-radius: 4px;\n  color: #f44336;\n}\n\n.no-users {\n  text-align: center;\n  padding: 20px;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n@media (max-width: 768px) {\n  .modal {\n    width: 95%;\n  }\n}\n\n.create-user-button {\n  background-color: #2196F3;\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 1rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.create-user-button:hover {\n  background-color: #1976D2;\n}\n\n/* Responsive styles */\n@media (max-width: 1200px) {\n  .user-management {\n    padding: 1rem;\n  }\n  \n  .table-container {\n    border-radius: 0;\n    width: 100%;\n  }\n}\n\n/* Custom scrollbar for better UX */\n.table-container::-webkit-scrollbar {\n  height: 8px;\n}\n\n.table-container::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.table-container::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 4px;\n}\n\n.table-container::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.editable-cell {\n  cursor: pointer;\n  padding: 0.5rem;\n  display: block;\n  border-radius: 4px;\n  transition: background-color 0.2s;\n}\n\n.editable-cell:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.editable-input {\n  width: 100%;\n  padding: 0.5rem;\n  border: 2px solid #2196F3;\n  border-radius: 4px;\n  background-color: rgba(255, 255, 255, 0.1);\n  color: white;\n  font-size: inherit;\n  font-family: inherit;\n}\n\n.editable-input:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.25);\n}\n\n.role-select {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: white;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  padding: 8px 12px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 14px;\n  min-width: 120px;\n  transition: all 0.2s ease;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='white'%3e%3cpath d='M7 10l5 5 5-5z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 8px center;\n  background-size: 20px;\n  padding-right: 32px;\n}\n\n.role-select:hover {\n  border-color: rgba(255, 255, 255, 0.3);\n  background-color: rgba(255, 255, 255, 0.15);\n}\n\n.role-select:focus {\n  outline: none;\n  border-color: #2196F3;\n  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.25);\n}\n\n.role-select option {\n  background-color: #011029;\n  color: white;\n  padding: 8px;\n}\n\n.status-badge {\n  width: 100px;\n  padding: 0.5rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  text-align: center;\n  transition: all 0.3s ease;\n}\n\n.status-badge.active {\n  background-color: rgba(76, 175, 80, 0.2);\n  color: #4CAF50;\n}\n\n.status-badge.inactive {\n  background-color: rgba(244, 67, 54, 0.2);\n  color: #f44336;\n}\n\n.status-badge:hover {\n  opacity: 0.8;\n}\n\n.actions-cell {\n  display: flex;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.delete-btn {\n  background: none;\n  border: none;\n  color: rgba(244, 67, 54, 0.7);\n  cursor: pointer;\n  padding: 0.5rem;\n  font-size: 1.1rem;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n}\n\n.delete-btn:hover {\n  color: #f44336;\n  transform: scale(1.1);\n}\n\n/* Header with create button */\n.header-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.create-user-button {\n  background-color: #2196F3;\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: background-color 0.3s;\n}\n\n.create-user-button:hover {\n  background-color: #1976D2;\n}\n\n/* Modal styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal {\n  background: #011029;\n  padding: 2rem;\n  border-radius: 8px;\n  width: 90%;\n  max-width: 500px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);\n  color: white;\n}\n\n.modal h3 {\n  margin-top: 0;\n  margin-bottom: 1.5rem;\n}\n\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: white;\n}\n\n.form-group input,\n.form-group select {\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n  font-size: 1rem;\n  background-color: rgba(255, 255, 255, 0.1);\n  color: white;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #2196F3;\n  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.25);\n}\n\n.modal-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 1.5rem;\n}\n\n.submit-button {\n  padding: 0.5rem 1rem;\n  background-color: #2196F3;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.submit-button:hover {\n  background-color: #1976D2;\n}\n\n.cancel-button {\n  padding: 0.5rem 1rem;\n  background-color: #f44336;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.cancel-button:hover {\n  background-color: #d32f2f;\n}\n\n/* Responsive styles */\n@media (max-width: 768px) {\n  .modal-overlay {\n    padding: 1rem;\n  }\n\n  .modal-content {\n    padding: 1.5rem;\n    max-height: 85vh; /* Slightly smaller on mobile */\n  }\n\n  .header-actions {\n    flex-direction: column;\n    gap: 1rem;\n    text-align: center;\n  }\n  \n  .create-user-button {\n    width: 100%;\n  }\n}\n\n/* Add smooth scrollbar styling */\n.modal-content::-webkit-scrollbar {\n  width: 8px;\n}\n\n.modal-content::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.modal-content::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 4px;\n}\n\n.modal-content::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n/* Optional: Add a close button at the top */\n.modal-close {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  padding: 0.5rem;\n  line-height: 1;\n}\n\n.modal-close:hover {\n  color: #2196F3;\n}\n\n.loading-container,\n.error-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n  padding: 2rem;\n}\n\n.loading {\n  color: white;\n  font-size: 1.2rem;\n}\n\n.error {\n  color: #f44336;\n  font-size: 1.2rem;\n  text-align: center;\n  padding: 1rem;\n  background-color: rgba(244, 67, 54, 0.1);\n  border-radius: 4px;\n  max-width: 600px;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #2196F3;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.refresh-button {\n  background-color: #2196F3;\n  color: white;\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-bottom: 1rem;\n}\n\n.refresh-button:hover {\n  background-color: #1976D2;\n}\n\n.last-refresh {\n  font-size: 0.8rem;\n  color: white;\n  margin-bottom: 1rem;\n}\n\n/* Column widths */\nth:nth-child(1), td:nth-child(1) { width: 20%; } /* Name */\nth:nth-child(2), td:nth-child(2) { width: 25%; } /* Email */\nth:nth-child(3), td:nth-child(3) { width: 15%; } /* Role */\nth:nth-child(4), td:nth-child(4) { width: 15%; } /* Created */\nth:nth-child(5), td:nth-child(5) { width: 15%; } /* Last Login */\nth:nth-child(6), td:nth-child(6) { width: 10%; } /* Actions */\n\n.user-controls {\n  margin-bottom: 1rem;\n}\n\n.add-user-button {\n  padding: 0.5rem 1rem;\n  background-color: #2196F3;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.add-user-button:hover {\n  background-color: #1976D2;\n}\n\n.edit-button {\n  padding: 0.5rem 1rem;\n  background-color: #2196F3;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.edit-button:hover {\n  background-color: #1976D2;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 200px;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid #f3f3f3;\n  border-top: 4px solid #2196F3;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.error-container {\n  padding: 1rem;\n  background-color: rgba(244, 67, 54, 0.1);\n  border: 1px solid rgba(244, 67, 54, 0.3);\n  border-radius: 4px;\n  margin: 1rem 0;\n}\n\n.error-message {\n  color: #f44336;\n  margin: 0;\n}\n\n.no-users {\n  text-align: center;\n  padding: 2rem;\n  background-color: rgba(255, 255, 255, 0.1);\n  border-radius: 4px;\n}\n\n/* Make table responsive */\n@media screen and (max-width: 1024px) {\n  .table-container {\n    width: 100%;\n    border-radius: 0;\n  }\n  \n  .user-management {\n    padding: 1rem;\n  }\n}\n\n/* Style for editable cells */\ntd span {\n  cursor: pointer;\n  padding: 0.25rem;\n  border-radius: 4px;\n}\n\ntd span:hover {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\ntd input {\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n  font-size: inherit;\n  font-family: inherit;\n  background-color: rgba(255, 255, 255, 0.1);\n  color: white;\n}\n\ntd input:focus {\n  outline: none;\n  border-color: #2196F3;\n  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.25);\n}\n\n.modal-error {\n  background-color: rgba(244, 67, 54, 0.1);\n  color: #f44336;\n  padding: 10px;\n  border-radius: 4px;\n  margin-bottom: 1rem;\n  border: 1px solid rgba(244, 67, 54, 0.3);\n}\n\n.form-group input:disabled,\n.form-group select:disabled,\nbutton:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.submit-button:disabled {\n  background-color: #ccc;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  padding: 0.5rem;\n  color: white;\n}\n\n.close-button:hover {\n  color: #2196F3;\n}\n\n.close-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.try-again-button {\n  margin-left: 1rem;\n  padding: 0.25rem 0.5rem;\n  background-color: #f44336;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.try-again-button:hover {\n  background-color: #d32f2f;\n}\n\n.password-input-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.password-input-container input {\n  padding-right: 40px; /* Make room for the eye icon */\n  width: 100%;\n}\n\n.password-toggle {\n  position: absolute;\n  right: 10px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 5px;\n  display: flex;\n  align-items: center;\n  color: white;\n}\n\n.password-toggle:hover {\n  color: #2196F3;\n}\n\n.password-toggle:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.password-toggle svg {\n  width: 20px;\n  height: 20px;\n}\n\n/* Update existing form-group styles */\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: white;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 4px;\n  font-size: 1rem;\n  background-color: rgba(255, 255, 255, 0.1);\n  color: white;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #2196F3;\n  box-shadow: 0 0 0 2px rgba(33, 150, 243, 0.25);\n}\n\n.location-cell {\n  min-width: 250px;\n  padding: 0.5rem !important;\n}\n\n.location-select-container {\n  width: 100%;\n}\n\n.location-select__control {\n  min-height: 38px !important;\n  background-color: rgba(255, 255, 255, 0.1) !important;\n  border-color: rgba(255, 255, 255, 0.2) !important;\n  border-radius: 4px !important;\n}\n\n.location-select__control:hover {\n  border-color: #2196F3 !important;\n}\n\n.location-select__control--is-focused {\n  border-color: #2196F3 !important;\n  box-shadow: 0 0 0 1px #2196F3 !important;\n}\n\n.location-select__menu {\n  background-color: #011029 !important;\n  border: 1px solid rgba(255, 255, 255, 0.2) !important;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;\n}\n\n.location-select__option {\n  background-color: transparent !important;\n  color: white !important;\n  cursor: pointer !important;\n}\n\n.location-select__option--is-focused {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n}\n\n.location-select__option--is-selected {\n  background-color: rgba(33, 150, 243, 0.2) !important;\n}\n\n.location-select__multi-value {\n  background-color: rgba(255, 255, 255, 0.1) !important;\n  border-radius: 4px !important;\n}\n\n.location-select__multi-value__label {\n  color: white !important;\n  padding: 2px 6px !important;\n}\n\n.location-select__multi-value__remove {\n  color: white !important;\n  cursor: pointer !important;\n  padding: 0 4px !important;\n}\n\n.location-select__multi-value__remove:hover {\n  background-color: rgba(244, 67, 54, 0.2) !important;\n  color: #f44336 !important;\n}\n\n.location-select__input {\n  color: white !important;\n}\n\n.location-select__placeholder {\n  color: rgba(255, 255, 255, 0.5) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
